import React from "react";
import { HiArrowRight, HiMail, HiChatAlt2, HiPhone } from "react-icons/hi";
import "../styles/global.css";

const footerColumns = [
  {
    heading: "Cloud Platform",
    links: [
      {
        label: "cPanel Web Hosting",
        href: "https://cyberin.in/cpanel-hosting",
      },
      {
        label: "Premium cPanel Hosting",
        href: "https://cyberin.in/cpanel-business-hosting",
      },
      {
        label: "Reseller Hosting",
        href: "https://cyberin.in/cpanel-reseller-hosting",
      },
      {
        label: "Website Builder",
        href: "https://cyberin.in/website-builder",
      },
    ],
  },
  {
    heading: "Resources",
    links: [
      { label: "Status", href: "https://stats.uptimerobot.com/28ywACNZp" },
      { label: "Knowledge Base", href: "https://help.cyberin.in/" },
      {
        label: "Developer Docs",
        href: "https://help.cyberin.in",
      },
      {
        label: "Customer Reviews",
        href: "https://cyberin.in/customer-reviews",
      },
    ],
  },
  {
    heading: "Company",
    links: [
      { label: "About Cyberin", href: "https://cyberin.in/about-us" },
      { label: "Careers", href: "https://cyberin.in/careers" },
      {
        label: "Partner Program",
        href: "https://cyberin.in/affiliate-program",
      },
      {
        label: "Terms & Conditions",
        href: "https://cyberin.in/terms",
      },
    ],
  },
];

const contactItems = [
  {
    icon: HiMail,
    label: "hello@cyberin.in",
    href: "mailto:hello@cyberin.in",
  },
  {
    icon: HiChatAlt2,
    label: "Submit a ticket",
    href: "https://cyberin.in/manage/submitticket.php?step=2&deptid=1",
  },
];

const AppFooter = () => {
  return (
    <footer className="page-footer">
      <div className="footer-pattern" aria-hidden="true" />
      <div className="footer-inner">
        <div className="footer-top">
          <div className="footer-brand">
            <div className="footer-logo">
              <img src="/logo-white.png" alt="Cyberin - Logo White" />
            </div>
            <p className="footer-tagline">
              Cyberin is a hosting company that's proudly independent and based
              in India. We've been around for over 12 years, and our mission is
              pretty simple, we want to make hosting fast, reliable, and easy
              for businesses that really care about stability
            </p>
            <div className="footer-contact-list">
              {contactItems.map(({ icon: Icon, label, href }) => (
                <a
                  key={label}
                  href={href}
                  className="footer-contact-item"
                  target={href.startsWith("http") ? "_blank" : undefined}
                  rel={
                    href.startsWith("http") ? "noopener noreferrer" : undefined
                  }
                >
                  <Icon />
                  <span>{label}</span>
                </a>
              ))}
            </div>
          </div>

          <div className="footer-columns">
            {footerColumns.map(({ heading, links }) => (
              <div key={heading} className="footer-column">
                <h4>{heading}</h4>
                <ul>
                  {links.map(({ label, href }) => (
                    <li key={label}>
                      <a href={href} target="_blank" rel="noopener noreferrer">
                        {label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-status">
            <span className="status-dot" />
            <a
              href="https://status.cyberin.in/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Platform status: Operational
            </a>
          </div>
          <div className="footer-legal">
            © {new Date().getFullYear()} Cyberin. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default AppFooter;
